import React, { useEffect, useState } from 'react';
import Avatar from '../../submodule/img/01.jpg';

import { Upload } from 'antd';
import { useNavigate, useParams } from 'react-router';
import { getUserById } from '../../redux/actions/user/getUserById';
import { useDispatch, useSelector } from 'react-redux';
import Input from '../../components/Input/Input';
import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import { resetPasswordUser } from '../../redux/actions/user/resetPasswordUser';
import { resetGetUserById, resetResetPasswordUser, resetUpdateEmailUser, resetUpdateUser } from '../../redux/slices/user.slice';
import { updateEmailUser } from '../../redux/actions/user/updateEmailUser';
import { updateUser } from '../../redux/actions/user/updateUser';
import Loading from '../../components/Loading/Loading';

function EditUser() {
  const [editState, setEditState] = useState(false); // This is an EditState for role
  const [roleState, setRoleState] = useState(false);
  const [vacancyState, setVacancyState] = useState(false);
  const [userState, setUser] = useState('ivanov');
  const [passwordState, setPassword] = useState('iuhew9809w');
  const [fileList, setFileList] = useState([]);
  const [totalEditState, setTotalEditState] = useState(false);
  const form = useForm({
    defaultValues: {
      email: '',
      fio: '',
    },
  });
  const navigate = useNavigate();
  const { userId } = useParams();
  const onChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  const handleChange = (e) => {
    if (e.target.name === 'user') {
      setUser(e.target.value);
    } else {
      setPassword(e.target.value);
    }
  };

  const handleTotalEdit = () => {
    setTotalEditState(!totalEditState);
  };

  const handleEdit = () => {
    setEditState(true);
  };

  const handleCancel = () => {
    setEditState(false);
  };

  const handleRole = () => {
    setRoleState(!roleState);
  };

  const handleVacancyList = () => {
    setVacancyState(!vacancyState);
  };
  const dispatch = useDispatch();
  const {
    getUserById: { data: getUserByIdData, error: getUserByIdError, loading: getUserByIdLoading },
    resetPasswordUser: { data: resetPasswordUserData, error: resetPasswordUserError, loading: resetPasswordUserLoading },
    updateUser: { data: updateUserData, error: updateUserError, loading: updateUserLoading },
    updateEmailUser: { data: updateEmailUserData, error: updateEmailUserError, loading: updateEmailUserLoading },
  } = useSelector((state) => state.user);
  useEffect(() => {
    if (updateUserData && updateEmailUserData) {
      Swal.fire({
        title: 'Данные контрагента успешно изменены',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      });
      dispatch(resetUpdateEmailUser());
      dispatch(resetUpdateUser());
      dispatch(getUserById(userId));
      setTotalEditState(false);
    }
  }, [updateUserData, updateEmailUserData]);

  useEffect(() => {
    dispatch(getUserById(userId));
  }, [userId]);
  useEffect(() => {
    return () => {
      form.reset();
      dispatch(resetGetUserById());
    };
  }, []);

  useEffect(() => {
    if (getUserByIdData) {
      form.setValue('email', getUserByIdData?.email);
      form.setValue('fio', getUserByIdData?.full_name);
    }
  }, [getUserByIdData]);

  const handleResetPassword = () => {
    Swal.fire({
      title: 'Вы действительно хотите сбросить пароль контрагента?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(resetPasswordUser(userId));
      }
    });
  };
  useEffect(() => {
    if (resetPasswordUserData) {
      Swal.fire({
        title: 'Новый пароль контрагента отправлен на почту',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      });
      dispatch(resetResetPasswordUser());
    }
  }, [resetPasswordUserData]);

  const onSubmit = (data) => {
    Swal.fire({
      title: 'Вы действительно хотите изменить данные контрагента?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(updateEmailUser({ id: userId, email: data.email }));
        dispatch(updateUser({ id: userId, fullName: data.fio, phone: getUserByIdData.phone }));
      }
    });
  };
  const isLoading = updateUserLoading || updateEmailUserLoading || resetPasswordUserLoading;
  return (
    <div className="w-full flex flex-1 mt-10 p-1">
      <div className="container relative flex flex-1 flex-col mx-auto max-w-[1163px]">
        <div className="flex flex-col sm:flex-row w-full gap-3 ">
          <div className="flex w-full sm:w-[20%] mb-2 justify-center">
            {totalEditState ? (
              <div className="flex justify-center p-5">
                <Upload action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188" listType="picture-card" fileList={fileList} onChange={onChange} onPreview={onPreview}>
                  {fileList.length < 1 && 'ВыгрузитьЬ'}
                </Upload>
              </div>
            ) : (
              <div className="bg-[#E5E5E5] w-[160px] h-[160px] m-5 flex items-center justify-center rounded-lg">
                <svg xmlns="http://www.w3.org/2000/svg" width="64px" height="64px" viewBox="0 0 24 24">
                  <path fill="rgba(0,0,0,0.6)" d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4" />
                </svg>
              </div>
            )}
          </div>
          <div className="flex flex-col w-full sm:w-[50%] mb-2 p-5 gap-3 relative">
            {isLoading && <Loading />}
            <div className="">{totalEditState ? <Input form={form} name="fio" placeholder={'Имя'} disabled={isLoading} /> : <label className=" text-lg ">{getUserByIdData?.full_name}</label>}</div>
            <div className="">
              <Input
                form={form}
                name="email"
                placeholder={'Email'}
                rules={{
                  required: { value: true, message: '*Обязательное поле для заполнения' },
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: 'Неверный формат почты',
                  },
                }}
                disabled={!totalEditState || isLoading}
              />
            </div>
            {totalEditState && (
              <button onClick={handleResetPassword} type="button" className=" text-center text-[14px] border rounded py-2 px-4 text-white    break-words p-2  hover:bg-red-600 bg-red-500 w-[130px]" disabled={isLoading}>
                Сброс пароля
              </button>
            )}
            {!totalEditState ? (
              <>
                <button type="button" className="text-center border rounded py-2 px-4 bg-button text-white hover:bg-button-hov  w-full md:w-auto transition ease-in-out duration-300" onClick={handleTotalEdit}>
                  Pедактировать
                </button>
                <button
                  onClick={() => {
                    navigate(-1);
                  }}
                  type="button"
                  class="text-center border rounded py-2 px-4  text-button border-button border-1 w-full md:w-auto hover:text-white bg-white hover:bg-button transition ease-in-out duration-300">
                  Назад
                </button>
              </>
            ) : (
              <>
                <button type="button" className="text-center border rounded py-2 px-4 bg-button text-white hover:bg-button-hov  w-full md:w-auto transition ease-in-out duration-300" onClick={form.handleSubmit(onSubmit)} disabled={isLoading}>
                  Cохранить
                </button>
                <button
                  onClick={() => {
                    setTotalEditState(false);
                  }}
                  type="button"
                  class="text-center border rounded py-2 px-4  text-button border-button border-1 w-full md:w-auto hover:text-white bg-white hover:bg-button transition ease-in-out duration-300"
                  disabled={isLoading}>
                  Отмена
                </button>
              </>
            )}
            {/* <button type="button" className="text-center border rounded py-2 px-4 bg-button text-white hover:bg-button-hov mr-2 w-full md:w-auto transition ease-in-out duration-300" onClick={handleRole}>
              Полномочия
            </button>
            {roleState ? (
              <>
                <div className="">
                  <div className="relative flex gap-x-3">
                    <div className="flex h-6 items-center">
                      <input id="role1" name="role1" type="checkbox" className="h-4 w-4 rounded border-gray-300 text-blue-500 focus:ring-blue-500" />
                    </div>
                    <div className="text-sm leading-6">
                      <label htmlFor="role1" className="font-medium text-gray-900">
                        Полномочие администратора
                      </label>
                    </div>
                  </div>
                </div>
                <div className="">
                  <div className="relative flex gap-x-3">
                    <div className="flex h-6 items-center">
                      <input id="role2" name="role2" type="checkbox" className="h-4 w-4 rounded border-gray-300 text-blue-500 focus:ring-blue-500" />
                    </div>
                    <div className="text-sm leading-6">
                      <label htmlFor="role2" className="font-medium text-gray-900">
                        Полномочие администратора
                      </label>
                    </div>
                  </div>
                </div>
                <div className="">
                  <div className="relative flex gap-x-3">
                    <div className="flex h-6 items-center">
                      <input id="role3" name="role3" type="checkbox" className="h-4 w-4 rounded border-gray-300 text-blue-500 focus:ring-blue-500" />
                    </div>
                    <div className="text-sm leading-6">
                      <label htmlFor="role3" className="font-medium text-gray-900">
                        Полномочие администратора
                      </label>
                    </div>
                  </div>
                </div>
                <div className="">
                  <div className="relative flex gap-x-3">
                    <div className="flex h-6 items-center">
                      <input id="role4" name="role4" type="checkbox" className="h-4 w-4 rounded border-gray-300 text-blue-500 focus:ring-blue-500" />
                    </div>
                    <div className="text-sm leading-6">
                      <label htmlFor="role4" className="font-medium text-gray-900">
                        Полномочие администратора
                      </label>
                    </div>
                  </div>
                </div>
                {!editState ? (
                  <div className="flex flex-row gap-3">
                    <button type="button" className="text-center border rounded py-2 px-4 bg-button text-white hover:bg-button-hov mr-2 w-full md:w-auto transition ease-in-out duration-300" onClick={handleEdit}>
                      Редактировать
                    </button>
                    <button type="button" className="text-center border rounded py-2 px-4  text-button border-button border-1 w-full md:w-auto hover:text-white bg-white hover:bg-button transition ease-in-out duration-300">
                      Удалить
                    </button>
                  </div>
                ) : (
                  <div className="flex gap-3">
                    <button type="button" className="text-center border rounded py-2 px-4  text-button border-button border-1 w-full md:w-auto hover:text-white bg-white hover:bg-button transition ease-in-out duration-300" onClick={handleCancel}>
                      Отмена
                    </button>
                  </div>
                )}
              </>
            ) : (
              ''
            )}
            <button type="button" className="text-center border rounded py-2 px-4 bg-button text-white hover:bg-button-hov mr-2 w-full md:w-auto transition ease-in-out duration-300" onClick={handleVacancyList}>
              Вакансии
            </button> */}
          </div>
        </div>
        {vacancyState ? (
          <div className="flex">
            <div className="hidden sm:block w-[20%]"></div>
            <div className="w-full sm:w-[55%] sm:px-8 overflow-x-auto">
              <div className="border-1 shadow-md p-4 min-w-full inline-block align-middle">
                <div className="overflow-hidden">
                  <table className="min-w-full divide-y divide-gray-200">
                    <tbody className="divide-y divide-gray-200 ">
                      <tr>
                        <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-800">209</td>
                        <td className="flex flex-col px-2 py-2 whitespace-nowrap text-sm text-gray-800">
                          <p>Горничная в отель</p>
                          <p className="text-[#D9D9D9]">Nikolay</p>
                        </td>
                        <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-800">HR 2</td>
                        <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-800">
                          <button type="button" className="text-center border rounded py-2 px-2  text-button border-button border-1 w-full md:w-auto hover:text-white bg-white hover:bg-button transition ease-in-out duration-300">
                            Отклики
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-800">210</td>
                        <td className="flex flex-col px-2 py-2 whitespace-nowrap text-sm text-gray-800">
                          <p>Разнорабочий</p>
                          <p className="text-[#D9D9D9]">Annushuka</p>
                        </td>
                        <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-800">разовый</td>
                        <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-800">
                          <button type="button" className="text-center border rounded py-2 px-2  text-button border-button border-1 w-full md:w-auto hover:text-white bg-white hover:bg-button transition ease-in-out duration-300">
                            Отклики
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-800">216</td>
                        <td className="flex flex-col px-2 py-2 whitespace-nowrap text-sm text-gray-800">
                          <p>Комплектовщик на склад</p>
                          <p className="text-[#D9D9D9]">Anna</p>
                        </td>
                        <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-800">стартовый</td>
                        <td className="px-2 py-2 whitespace-nowrap text-sm text-gray-800">
                          <button type="button" className="text-center border rounded py-2 px-2  text-button border-button border-1 w-full md:w-auto hover:text-white bg-white hover:bg-button transition ease-in-out duration-300">
                            Отклики
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}

export default EditUser;
